import {
  Face6 as AccountCircle,
  Password as PasswordIcon,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { motion } from "framer-motion";
import { jwtDecode } from "jwt-decode";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Alert } from "@mui/material";
import "../../resources/css/vyg.css";
import loginImage from "../../resources/images/vyoog.png";
import { adminLogin } from "../utils/utils";
import Password from "../auth/Password";

const circleVariants = {
  animate: {
    y: [0, -20, 0],
    scale: [1, 1.1, 1],
    opacity: [0.7, 1, 0.7],
    transition: { duration: 5, repeat: Infinity, ease: "easeInOut" },
  },
};

const stepVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};


const GoogleLoginComponent = ({ setError }) => {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: (response) => {
      console.log("Access Token:", response.access_token);
      exchangeGoogleTokenForKeycloakToken(response.access_token)
    },
    onError: () => console.log("Login Failed"),
    scope: "openid profile email",
    flow: "implicit",
  });


  const checkUsernameExists = async (username) => {
    try {


      // Step 2: Search for the user by username
      const userResponse = await fetch(`${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?username=${username}`, {
        method: "GET",
        headers: await adminLogin(),
      });

      if (!userResponse.ok) {
        throw new Error("Failed to fetch users");
      }

      const users = await userResponse.json();
      return users; // Returns true if username exists, false otherwise
    } catch (error) {
      console.error("Error checking username:", error);
      return false;
    }
  };

  const updateUserProfile = async (username, firstName, lastName, photoUrl, tenant) => {
    try {
      // Step 1: Get user details to retrieve the user ID
      const userResponse = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?username=${username}`,
        {
          method: "GET",
          headers: await adminLogin(), // Fetch admin token headers
        }
      );

      const users = await userResponse.json();

      if (!users.length) {
        console.error("User not found");
        return;
      }

      const userId = users[0].id; // Get user ID from response

      // Step 2: Update user details in Keycloak
      const updateResponse = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${userId}`,
        {
          method: "PUT",
          headers: {
            ...(await adminLogin()), // Admin token headers
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: username,
            firstName,
            lastName,
            attributes: {
              tenant,
              photo: [photoUrl], // Storing photo in attributes
            },
          }),
        }
      );

      if (updateResponse.ok) {
        console.log("User updated successfully!");
      } else {
        console.error("Failed to update user:", await updateResponse.text());
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const googleAccountLink = async (userId, googleUserId, username) => {

    const linkResponse = await fetch(
      `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${userId}/federated-identity/google`,
      {
        method: "POST",
        headers: {
          ...(await adminLogin()),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: googleUserId, // The external provider's user ID
          userName: username,
        }),
      }
    );

    if (linkResponse.ok) {
      console.log(`User linked with  successfully!`);
    } else {
      console.log(`User linkedError`);
    }

  }


  const validateGoogleToken = async (accessToken) => {
    try {
      const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        return data
      } else {
        console.error("Error fetching user info:", data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const exchangeGoogleTokenForKeycloakToken = async (idToken) => {
    try {
      const profileInfo = await validateGoogleToken(idToken)
      const userExist = await checkUsernameExists(profileInfo.email)
      if (userExist.length === 0) {
        setError("Email not registered. Please check or sign up.")
        return false
      } else {
        if (!userExist[0].firstName) {

          await updateUserProfile(
            profileInfo.email,           // Username (Email in this case)
            profileInfo.given_name,      // First Name
            profileInfo.family_name,     // Last Name
            profileInfo.picture,         // Profile Picture URL
            userExist[0]?.attributes?.tenant?.[0] // Ensure safe access to tenant attribute
          );

          await googleAccountLink(userExist[0]?.id, profileInfo.sub, profileInfo.email)

        }
      }

      console.log("idToken", idToken)

      const response = await fetch(`${process.env.REACT_APP_USER_MGMT}/realms/eVyoog/protocol/openid-connect/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          client_id: "eVyoog",
          client_secret: "ssFF0O7wX5UlmWECCxjfOmflw4WRSJng",
          grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
          subject_token: idToken,
          subject_issuer: "google",
        }),
      });
 console.log("REACT_APP_OAUTH_URLaaa")
      const keycloakData = await response.json();
      console.log("keycloakData", keycloakData)
      localStorage.setItem("vyg_access_token", keycloakData.access_token);
      localStorage.setItem("vyg_refresh_token", keycloakData.refresh_token);

      const decodedToken = jwtDecode(keycloakData.access_token);
      localStorage.setItem("vyg_login_user", decodedToken.given_name || "Unknown user");


      navigate("/ticket");
      window.location.reload();


      return keycloakData.access_token;
    } catch (error) {
      console.error("Token exchange failed:", error);
      return null;
    }
  };



  return <Button
    fullWidth
    variant="outlined"
    sx={{
      textTransform: "none",
      color: "black",
      borderColor: "gray",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    onClick={login}
    startIcon={
      <img
        src="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
        alt="Google Logo"
        style={{ width: 20, height: 20 }}
      />
    }
  >
    Sign in with Google
  </Button>
};

const Login = () => {
  const [step, setStep] = useState(1); // 1 = Email, 2 = Password

  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleShowPasword = () => { setShowPassword(!showPassword) };
  const [error, setError] = useState("");

  const loginAuth = async (username, password) => {

    const response = await fetch(process.env.REACT_APP_OAUTH_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        username,
        password,
        client_id: "eVyoog",
        client_secret: "ssFF0O7wX5UlmWECCxjfOmflw4WRSJng",
        grant_type: "password",
      }),
    });
    console.log("REACT_APP_OAUTH_URLaaa")
    console.log("sss")
    const data = await response.json();

    // 🔴 Handle error case
    if (!response.ok) {
  
      if (
        data.error === "invalid_grant" &&
        data.error_description === "Account is not fully set up"
      ) {localStorage.setItem("username", username);
       // Redirect to custom reset password page
      navigate("/password", { state: { username } });
       
        return;
      }
  
      setError(data.error_description || "Login failed");
      return;
    }
  
    // 🟢 Success case
    localStorage.setItem("vyg_access_token", data.access_token);
    localStorage.setItem("vyg_refresh_token", data.refresh_token);
  
    const decodedToken = jwtDecode(data.access_token);
    localStorage.setItem("vyg_login_user", decodedToken.given_name || "Unknown user");
  
    navigate("/ticket");
    window.location.reload();
  };


  return (
    <div className="home">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Floating animated circles */}
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            variants={circleVariants}
            animate="animate"
            style={{
              position: "absolute",
              width: `${20 + i * 1}px`,
              height: `${20 + i * 1}px`,
              background: "rgba(255, 255, 255, 0.2)",
              borderRadius: "50%",
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
          />
        ))}

        <motion.div variants={stepVariants} initial="hidden" animate="visible">
          <Paper
            elevation={10}
            sx={{
              p: 4,
              borderRadius: 3,
              textAlign: "center",
              width: 600,
              background: "#fff",
              color: "#000",
            }}
          >

            {/* AI Logo */}
            <motion.img
              src={loginImage}
              alt="AI Logo"
              style={{ width: 100, marginBottom: 10 }}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            />
            <hr className="hr" />
            <motion.div initial={{ opacity: 0, y: -60 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.5 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "#1290d2",
                  fontWeight: "bold",
                  letterSpacing: 1.2,
                  textTransform: "uppercase",
                  textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
                }}
              >
                Login
              </Typography>
            </motion.div>
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            <br />
            {/* Step 1: Email Input */}
            {step === 1 && (
              <>
                <TextField
                  label="Username"
                  variant="standard"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ display: "flex", alignItems: "center", marginRight: "0.5rem" }}>
                        <AccountCircle />
                      </Box>
                    ),
                  }}
                />
                <br /><br />

                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  onClick={() => setStep(2)}
                  disabled={!username} // Disable button if username is empty
                  endIcon={<ArrowForwardIcon />} // Icon at the end of the button
                >
                  Next
                </Button>
              </>
            )}

            {/* Step 2: Password Input */}
            {step === 2 && (
              <>

                <TextField
                  type={showPassword ? 'text' : 'password'}
                  label="Password"
                  variant="standard"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ display: "flex", alignItems: "center", marginRight: "0.5rem" }}>
                        <PasswordIcon />
                      </Box>
                    ),
                    endAdornment: (

                      <InputAdornment position="end">
                        <IconButton onClick={handleShowPasword} >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>

                    ),
                  }}
                />


                <Button
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2, mb: 2, background: "#1290d2", color: "#fff", fontWeight: "bold" }}
                  onClick={() => loginAuth(username, password)}
                >
                  Sign In
                </Button>
              </>
            )}


            {/* Sign in with Google */}
            {step === 1 && (
              <>
                <br />
                <Typography variant="body2" textAlign="center" sx={{ color: "#b0b0b0", mt: 2 }}>
                  or
                </Typography>

                <br />

                <GoogleOAuthProvider clientId="1038184094845-70foh19lm7fo0nvbb8587ov3o5bejgrq.apps.googleusercontent.com">
                  <GoogleLoginComponent setError={setError} />
                </GoogleOAuthProvider>
              </>
            )}

            {/* Register Link */}
            <Typography variant="body2" sx={{ mt: 2 }}>
              Don't have an account?{" "}
              <Link href="/register" sx={{ textDecoration: "none", fontWeight: "bold", color: "#1290d2" }}>
                Register here
              </Link>
            </Typography>
          </Paper>
        </motion.div>
      </Box>
    </div>
  );
};

export default Login;
